import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function MobileAddon(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14 1c1.104 0 2 .897 2 2v2.21a6.015 6.015 0 016.524 5.986 6.016 6.016 0 01-5.782 6.004l-.225.004c-.174 0-.346-.007-.517-.022V21c0 1.103-.896 2-2 2H3.5c-1.103 0-2-.897-2-2V3c0-1.103.897-2 2-2H14zm0 17.394H3.5V21H14v-2.606zm-5.298.36a.951.951 0 110 1.901.951.951 0 010-1.902zM12.94 6.371H3.5v10.022l10.008.001-.082-.048a6.002 6.002 0 01-.523-9.948l.037-.027zm3.577.816a4.013 4.013 0 00-4.008 4.008 4.013 4.013 0 004.008 4.008 4.013 4.013 0 004.008-4.008 4.013 4.013 0 00-4.008-4.008zm0 1.05a1 1 0 011 1l-.001.948h.949a1 1 0 110 2h-.949v.949a1 1 0 11-2 0v-.949h-.947a1 1 0 110-2h.947v-.948a1 1 0 011-1zM14 3H3.5v1.372H14V3z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoMobileAddon = React.memo(MobileAddon);
export default MemoMobileAddon;